/**
 * joinWithHyphen — safe " - " joiner used by every Quick Add description
 * builder + cart-side preview.
 *
 * Why we need this
 * ----------------
 * Staff fills out 2–4 fields whose values compose the line shown on the
 * PDF: e.g. for Laminate it's `description - code - thickness`. When a
 * field is left blank we MUST NOT render "- CODE - THICKNESS" (leading
 * hyphen) or "CODE - - THICKNESS" (empty segment) — those look broken on
 * the customer's PDF. This helper drops every empty/whitespace-only
 * part and joins the rest with " - ".
 *
 * Examples
 * --------
 *   joinWithHyphen('', 'GL-1010', '2mm')      → 'GL-1010 - 2mm'
 *   joinWithHyphen('Matte', 'GL-1010', '')    → 'Matte - GL-1010'
 *   joinWithHyphen('', '', '')                → ''
 *   joinWithHyphen('Walnut', 'WL-22')         → 'Walnut - WL-22'
 *   joinWithHyphen(null, undefined, 'x')      → 'x'
 *
 * The same logic lives server-side in
 * `backend/utils/string_helpers.py::join_with_hyphen` so the PDF
 * renderer can rebuild identical strings from canonical fields.
 */
export function joinWithHyphen(...parts) {
  const cleaned = parts
    .map((p) => (p == null ? '' : String(p).trim()))
    .filter((p) => p.length > 0);
  return cleaned.join(' - ');
}

export default joinWithHyphen;
